<template>
  <div v-if="open" class="overlay" @click.self="$emit('close')">
    <div class="modal">
      <div class="modal-head">
        <div>
          <div class="eyebrow">Planes</div>
          <h3>{{ heading }}</h3>
        </div>
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>

      <p class="intro">
        {{ contextMessage || 'Un plan no solo quita anuncios: también desbloquea grupos ilimitados y hasta 100 usuarios registrados por grupo.' }}
      </p>

      <div class="plan-grid">
        <button
          v-for="plan in normalizedPlans"
          :key="plan.code"
          class="plan-card"
          @click="$emit('select', plan.code)"
        >
          <div class="plan-title">{{ plan.label }}</div>
          <div class="plan-price">{{ plan.price }}</div>
          <ul class="plan-list">
            <li>Sin anuncios</li>
            <li>Grupos ilimitados</li>
            <li>Hasta 100 usuarios por grupo</li>
            <li v-if="plan.code === 'lifetime'">Pago único</li>
            <li v-else>Renovación automática</li>
          </ul>
        </button>
      </div>

      <div class="footnote">
        <strong>Modo free:</strong> notas personales ilimitadas, 1 grupo máximo y hasta 4 personas por grupo.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanModal',
  props: {
    open: { type: Boolean, default: false },
    plans: { type: Array, default: () => [] },
    heading: { type: String, default: 'Quitar anuncios y ampliar grupos' },
    contextMessage: { type: String, default: '' },
  },
  emits: ['close', 'select'],
  computed: {
    normalizedPlans() {
      const fallback = [
        { code: 'monthly', label: 'Mensual', amount_mxn: 5 },
        { code: 'yearly', label: 'Anual', amount_mxn: 50 },
        { code: 'lifetime', label: 'Vitalicio', amount_mxn: 500 },
      ];

      const source = this.plans.length ? this.plans : fallback;
      return source.map((plan) => {
        const code = plan.code || plan.key || plan.id || 'yearly';
        const amount = Number(plan.amount_mxn || 0);
        const label = plan.label || (code === 'monthly' ? 'Mensual' : code === 'yearly' ? 'Anual' : 'Vitalicio');
        return {
          ...plan,
          code,
          label,
          amount_mxn: amount,
          price: `$${amount} MXN${code === 'lifetime' ? '' : ` / ${code === 'monthly' ? 'mes' : 'año'}`}`,
        };
      });
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.34);
  display: grid;
  place-items: center;
  padding: 24px;
  z-index: 70;
}
.modal {
  width: min(980px, 100%);
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 28px;
  padding: 24px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.18);
}
.modal-head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.eyebrow {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: .12em;
  color: #64748b;
}
h3 {
  margin: 6px 0 0;
  font-size: 30px;
  color: #0f172a;
}
.close-btn {
  border: none;
  background: transparent;
  font-size: 34px;
  color: #64748b;
  cursor: pointer;
}
.intro {
  margin: 12px 0 0;
  color: #475569;
  line-height: 1.55;
}
.plan-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}
.plan-card {
  text-align: left;
  border: 1px solid rgba(148,163,184,.18);
  background: linear-gradient(180deg, rgba(255,255,255,.98), rgba(248,250,252,.96));
  border-radius: 22px;
  padding: 18px;
  cursor: pointer;
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.plan-card:hover {
  transform: translateY(-2px);
  border-color: rgba(59,130,246,.32);
  box-shadow: 0 14px 30px rgba(15,23,42,.08);
}
.plan-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}
.plan-price {
  margin-top: 10px;
  font-size: 28px;
  font-weight: 900;
  color: #111827;
}
.plan-list {
  margin: 14px 0 0;
  padding-left: 18px;
  color: #475569;
  line-height: 1.55;
}
.footnote {
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(248,250,252,.92);
  color: #334155;
}
@media (max-width: 860px) {
  .plan-grid {
    grid-template-columns: 1fr;
  }
  .modal {
    overflow-y: scroll;
    max-height: 90vh;
  }
}
</style>
